import { array, boolean, object, type InferOutput } from 'valibot'
import canUnitDirectAttackEntity from '../../entity/canUnitDirectAttackEntity'
import canUnitRangedAttackEntity from '../../entity/canUnitRangedAttackEntity'
import { EntitySchema, type Entity } from '../../entity/index'
import isEntityUnit from '../../entity/isEntityUnit'
import type { HasHP } from '../../has_hp'
import type { HasPlayerId } from '../../player/has_player_id'
import type { EntityGridXYV2 } from '../EntityGridXYV2.type'

type EnemyEntity = Entity & HasPlayerId & HasHP

export const EnemyListRowSchema = object({
  canDirectAttack: boolean(),
  canRangedAttack: boolean(),
  ent: EntitySchema, // Entity & HasPlayerId & HasHP
})

export type EnemyListRow = InferOutput<typeof EnemyListRowSchema>

export const EnemyListSchema = array(EnemyListRowSchema)

export type EnemyList = InferOutput<typeof EnemyListSchema>

export default function createEnemyListGrid(
  // full state width
  gridWidth: number,
  // full state height
  gridHeight: number,
  // full state ents as GridXY
  grid: EntityGridXYV2,
  // unit attempting to approach enemies
  unit: Entity
) {
  const unitPlayerId = unit.player_id
  const data = new Array(gridWidth * gridHeight)
  for (let x = 0; x < gridWidth; x++) {
    for (let y = 0; y < gridHeight; y++) {
      const index = x + (y * gridWidth)
      const positionStack = grid[index]
      const list : EnemyList = []
      if (positionStack) {
        for (let index = 0; index < positionStack.length; index++) {
          const enemyEnt = positionStack[index]
          if (enemyEnt.player_id !== unitPlayerId) {
            if (isEntityUnit(enemyEnt)) {
              if (enemyEnt.taxi_id) {
                // ignore cargo, taxi will be used
                continue
              }
              list.push({
                canDirectAttack: canUnitDirectAttackEntity(unit, enemyEnt),
                canRangedAttack: canUnitRangedAttackEntity(unit, enemyEnt),
                ent: enemyEnt as EnemyEntity,
              })
            }
          }
        }
      }
      data[index] = list
    }
  }
  return data
}
